var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "是否可清空" } },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "small" },
              model: {
                value: _vm.clearable,
                callback: function($$v) {
                  _vm.clearable = $$v
                },
                expression: "clearable"
              }
            },
            [
              _c("el-radio-button", { attrs: { label: false } }, [
                _vm._v("否")
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: true } }, [_vm._v("是")])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28f36fdb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f36fdb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingIsClearable.vue
// module id = null
// module chunks = 